var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_33",
    "data-name": "Group 33",
    transform: "translate(-4988.5 -2080)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M5001.338,2086.169l-11.182-5.455a.7.7,0,0,0-1.013.633v.02a1.158,1.158,0,0,0,.034.281l1.073,4.29a.288.288,0,0,0,.248.217l4.715.524a.323.323,0,0,1,0,.642l-4.715.524a.288.288,0,0,0-.248.217l-1.073,4.29a1.158,1.158,0,0,0-.034.281v.02a.7.7,0,0,0,1.013.633l11.182-5.455a.925.925,0,0,0,0-1.662Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20",
    "data-name": "Rectangle 20",
    width: 14,
    height: 14,
    transform: "translate(4988.5 2080)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSend);
export default __webpack_public_path__ + "static/media/icon-send.3f534f7c18d15ecc1939567e893fe740.svg";
export { ForwardRef as ReactComponent };